import { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { format, startOfToday, subDays, addDays, addMonths, subMonths, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from "date-fns";
import { ReactComponent as Trashcan } from "../../assets/icons/trashcan.svg";
import { ReactComponent as LeftArrow } from "../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/rightArrow.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { ReactComponent as Refresh } from "../../assets/icons/refresh.svg";
import { ReactComponent as Filter } from "../../assets/icons/filter.svg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrowLeft.svg";
import { ReactComponent as SelectIcon } from "../../../common/assets/icons/selectIcon.svg";
import { ReactComponent as CloseBlackIcon } from "../../assets/icons/closeIcon.svg";
import { ReactComponent as Alarm } from "../../assets/icons/alarm.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/closeGrayIcon.svg";
import { ReactComponent as ToastNotice } from "../../assets/icons/toastNotice.svg";
import Input from "../../components/common/input";
import Button from "../../../common/components/button";
import SelectBox from "../../components/common/selectBox";
import TransactionTable from "./-components/TransactionTable";
import TransactionDetail from "./-components/TransactionDetail";
import FilterDetail from "./-components/FilterDetail";
import Excel from "../../components/common/excel";
import NewOrder from "./-components/NewOrder";
import { useGetOrder } from "../../../common/hooks/console/transaction/useGetOrder";
import { usePutOrderStatus } from "../../../common/hooks/console/transaction/usePutOrderStatus";
import useToastStore from "../../store/useToastStore";
import DailyMemo from "./-components/DailyMemo";
import { useSystemPopStore } from "../../store/useSystemPopStore";
import { useGetOrderCount } from "../../../common/hooks/console/transaction/useGetOrderCount";
import TableName from "../../components/common/tableName";
import { useGetCommonCancel } from "../../../common/hooks/common/useGetCommonCancel";
import { usePostCopy } from "../../../common/hooks/console/transaction/usePostOrderCopy";
import { usePutOrderCancel } from "../../../common/hooks/console/transaction/usePutOrderCancel";
import { useAuthStore } from "../../store/useAuthStore";
import { useGetAlertList } from "../../../common/hooks/console/member/useGetAlertList";
import { usePutAlertRead } from "../../../common/hooks/console/member/usePutAlertRead";
import Spinner from "../../../common/components/spinner";
import loginLogo from "../../../console/assets/images/receiptLogo.png";
import { usePutReceipt } from "../../../common/hooks/console/transaction/usePutReceipt";
import { useDeleteOrder } from "../../../common/hooks/console/transaction/useDeleteOrder";
import { useGetOrderDateCount } from "../../../common/hooks/console/transaction/useGetOrderDateCount";
import { useGetSalesStatistics } from "../../../common/hooks/console/transaction/useGetSalesStatistics";
import { makeIntComma } from "../../../common/hooks/utils/utils";
import DayPickerInput from "console/components/common/DayPickerInput";

const Transaction = () => {
    const { addToast } = useToastStore();
    const { showPop } = useSystemPopStore();
    const level = useAuthStore(state => state.m_level);
    const name = useAuthStore(state => state.m_name);

    const [searhParams] = useSearchParams();
    const orderNumber = searhParams.get("orderNumber");
    const orderId = searhParams.get("orderId");

    const [isRefreshing, setIsRefreshing] = useState(false);
    const [activeComponent, setActiveComponent] = useState<"TransactionDetail" | "NewOrder" | null>(null);
    const [userOrder, setUserOrder] = useState<boolean>(false);
    const [filterClick, setFilterClick] = useState(false);
    const [excelClick, setExcelClick] = useState(false);
    const [currentPage, setCurrentPage] = useState<number | null>(1);
    const [search, setSearch] = useState<string>("all_search");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");
    const [pageSize, setPageSize] = useState<number>(50);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [cancel, setCancel] = useState<number | string>(0);
    const [cancelPop, setCancelPop] = useState<boolean>(false);
    const [cancelDetail, setCancelDetail] = useState<string>("");
    const [tabs, setTabs] = useState<{ id: number; type: "detail" | "newOrder"; orderNumber?: string }[]>([]);
    const [activeTabId, setActiveTabId] = useState<number | null>(null);
    const [sortField, setSortField] = useState<string>("");
    const [sortOrder, setSortOrder] = useState<"ASC" | "DESC">("DESC");
    const [activeFilterType, setActiveFilterType] = useState<"header" | "detail">("header");
    const [cancelError, setCancelError] = useState<boolean>(false);
    const [salesStatisticsPopup, setSalesStatisticsPopup] = useState<boolean>(false);
    const [salesStatisticsOrderDate, setSalesStatisticsOrderDate] = useState<{
        start_date: Date | string;
        end_date: Date | string;
    }>({
        // start_date: new Date(),
        // end_date: new Date(),
        start_date: "",
        end_date: "",
    });
    const { mutate: getSalesStatistics, data: salesStatisticsData, isPending: isSalesStatisticsLoading } = useGetSalesStatistics();

    const today = startOfToday();
    // const formatted = format(today, "yyyy-MM-dd");
    const formatted = "";
    const [filterData, setFilterData] = useState<{
        start_date: string;
        end_date: string;
        order_status: number[];
        payment_status: number[];
        branch_type: number[];
        selected_customers?: string[];
        selected_branches?: string[];
        selected_delivery?: string[];
        today_order?: string;
        photo_unchecked?: string; // 준비완료 사진 미확인만 보기
    }>({
        start_date: formatted,
        end_date: formatted,
        order_status: [1, 2, 3, 4, 5, 6],
        payment_status: [1, 2],
        branch_type: [1, 2],
        selected_customers: [],
        selected_branches: [],
        selected_delivery: [],
    });
    const [headerFilter, setHeaderFilter] = useState<{
        order_status: number | null;
        branch_type: number | null;
        isToday: boolean;
        photoUnchecked: boolean; // 사진미확인 숫자 클릭 여부
    }>({
        order_status: null,
        branch_type: null,
        isToday: false,
        photoUnchecked: false,
    });
    const [changeStatus, setChangeStatus] = useState<boolean>(false);
    const [clearSelection, setClearSelection] = useState(false);
    const [detailRefetchMap, setDetailRefetchMap] = useState<Record<number, () => Promise<any>>>({});
    const [alarmPop, setAlarmPop] = useState<boolean>(false);
    // const [selectedQuickFilter, setSelectedQuickFilter] = useState<string | null>("today");
    const [selectedQuickFilter, setSelectedQuickFilter] = useState<string | null>(null);

    const statusRef = useRef<HTMLDivElement>(null);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    /*
    // 가운데(헤더+표) 영역의 실제 폭. 표 칸을 좁힐지는 패널 열림이 아니라 이 폭으로 정한다.
    // 패널이 열려도 화면이 넓으면 기본 폭을 쓰고, 패널이 없어도 좁으면 좁은 폭을 쓴다.
    // CSS @container 로도 되지만 container-type 이 안쪽 fixed 팝업의 기준 위치를 바꿔서 쓰지 않는다.
    */
    const centerRef = useRef<HTMLDivElement>(null);
    const [centerWidth, setCenterWidth] = useState<number | null>(null);
    useLayoutEffect(() => {
        const el = centerRef.current;
        if (!el) return;
        setCenterWidth(el.clientWidth);
        const observer = new ResizeObserver(([entry]) => setCenterWidth(entry.contentRect.width));
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    // 고객매출에서 상세정보 진입 시
    useEffect(() => {
        if (orderNumber && orderId) {
            // 상단의 매출 및 주문상태 필터를 전체로 초기화
            setSelectedQuickFilter(null);
            setFilterData(prev => ({ ...prev, start_date: "", end_date: "" }));

            // 검색 필드에 order_number
            setSearchTxt(orderNumber);
            setInputValue("1");
            setCurrentPage(1);

            // 해당 주문 상세 탭 열기
            handleSelectRow(Number(orderId));
        }
    }, [orderNumber, orderId]);

    const handleQuickFilterClick = (type: string, start: string, end: string, label: string) => {
        if (selectedQuickFilter === type) {
            setSelectedQuickFilter(null);
            setFilterData(prev => ({ ...prev, start_date: "", end_date: "" }));
        } else {
            setSelectedQuickFilter(type);
            setFilterData(prev => ({ ...prev, start_date: start, end_date: end }));
        }
        /*
        // 기간을 바꿀 때는 주문상태 선택을 푼다.
        // 특정 상태만 보고 있던 상태에서 기간만 바꾸면 조건이 겹쳐
        // 해당 기간에 건이 있는데도 비어 보인다.
        // 발주상태·사진미확인은 주문상태와 배타적으로 동작하므로 건드리지 않는다.
        */
        setHeaderFilter(prev => ({ ...prev, order_status: null }));
    };
    const getHeaderFilterAsFilterData = (): typeof filterData => {
        return {
            start_date: filterData?.start_date,
            end_date: filterData.end_date,
            order_status: headerFilter.order_status !== null ? [headerFilter.order_status] : [],
            payment_status: [],
            branch_type: headerFilter.branch_type !== null ? [headerFilter.branch_type] : [],
            selected_customers: [],
            selected_branches: [],
            selected_delivery: [],
            today_order: headerFilter.isToday ? "true" : "",
            photo_unchecked: headerFilter.photoUnchecked ? "true" : "",
        };
    };
    const handleOrderStatusClick = (value: number) => {
        setCurrentPage(1);
        setInputValue("1");
        setHeaderFilter(prev => ({
            order_status: prev.order_status === value ? null : value,
            branch_type: null,
            isToday: false,
            photoUnchecked: false,
        }));
        setActiveFilterType("header");
        setFilterData(prev => ({
            ...prev,
            order_status: [1, 2, 3, 4, 5, 6],
            payment_status: [1, 2],
            branch_type: [1, 2],
            selected_customers: [],
            selected_branches: [],
            selected_delivery: [],
        }));
    };
    const handleBranchTypeClick = (value: number) => {
        setCurrentPage(1);
        setInputValue("1");
        setHeaderFilter(prev => ({
            order_status: null,
            branch_type: prev.branch_type === value ? null : value,
            isToday: false,
            photoUnchecked: false,
        }));
        setActiveFilterType("header");
        setFilterData(prev => ({
            ...prev,
            order_status: [1, 2, 3, 4, 5, 6],
            payment_status: [1, 2],
            branch_type: [1, 2],
            selected_customers: [],
            selected_branches: [],
            selected_delivery: [],
        }));
    };
    /*
    // 사진미확인 필터
    // 요약바의 사진미확인 숫자를 누르면 해당 건만 보여준다.
    // 다른 주문상태/발주상태 필터와 마찬가지로 한 번 더 누르면 해제된다.
    */
    const handlePhotoUncheckedClick = () => {
        setCurrentPage(1);
        setInputValue("1");
        setHeaderFilter(prev => ({
            order_status: null,
            branch_type: null,
            isToday: false,
            photoUnchecked: !prev.photoUnchecked,
        }));
        setActiveFilterType("header");
        setFilterData(prev => ({
            ...prev,
            order_status: [1, 2, 3, 4, 5, 6],
            payment_status: [1, 2],
            branch_type: [1, 2],
            selected_customers: [],
            selected_branches: [],
            selected_delivery: [],
        }));
    };
    const handleNewOrderComplete = () => {
        if (tabs.length > 0) {
            setActiveComponent("TransactionDetail");
        } else {
            setActiveComponent(null);
        }
    };
    const handleSortField = (sortParam: string) => {
        const [field, order] = sortParam.split(",") as [string, "ASC" | "DESC"];
        setSortField(field);
        setSortOrder(order);
    };
    const statusOptions = [
        { value: 2, label: "접수완료" },
        { value: 3, label: "준비완료" },
        { value: 4, label: "배송완료" },
        { value: 6, label: "보류" },
    ];
    const getStatusLabel = (status: number | undefined) => {
        const allStatusOptions = [
            { value: 1, label: "미확인" },
            { value: 2, label: "접수완료" },
            { value: 3, label: "준비완료" },
            { value: 4, label: "배송완료" },
            { value: 5, label: "주문취소" },
            { value: 6, label: "보류" },
            { value: 7, label: "삭제" },
        ];

        return allStatusOptions.find(option => option.value === status)?.label || "알 수 없는 상태";
    };
    const handleSaveCopy = () => {
        showPop({
            title: "해당 주문건을 복사하시겠습니까?",
            content: "복사된 주문건은 <br /> [주문복사] 건으로 신규 등록 됩니다.",
            rightButton: "확인",
            type: "positive",
            onRightClick: () => {
                copyMutate(
                    {
                        order_idx: selectedIds,
                    },
                    {
                        onSuccess: () => {
                            addToast({
                                type: "success",
                                message: "해당 주문건이 복사되었습니다.",
                            });
                            setClearSelection(true);
                        },
                        onError: (error: any) => {
                            const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                            showPop({
                                title: errorMessage,
                                rightButton: undefined,
                                type: "negative",
                                onRightClick: () => {},
                            });
                        },
                    },
                );
            },
        });
    };
    const handleSaveCancel = () => {
        let hasError = false;
        if (!cancel) {
            setCancelError(true);
            hasError = true;
        } else {
            setCancelError(false);
        }
        if (hasError) return;

        showPop({
            title: "해당 주문건을 취소하시겠습니까?",
            content: "선택된 주문건은 [주문취소] 상태로<br /> 변경됩니다.",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                cancelMutate(
                    {
                        order_idx: selectedIds,
                        cancel_reason_idx: Number(cancel),
                        cancel_reason: cancelDetail,
                    },
                    {
                        onSuccess: () => {
                            addToast({
                                type: "success",
                                message: `${name}님이 주문취소 상태로 변경하었습니다.`,
                            });
                            setClearSelection(true);
                            setCancelPop(false);
                        },
                        onError: (error: any) => {
                            const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                            showPop({
                                title: errorMessage,
                                rightButton: undefined,
                                type: "negative",
                                onRightClick: () => {},
                            });
                        },
                    },
                );
            },
        });
    };
    const handleStatusSubmit = (value: number) => {
        const selectedLabel = getStatusLabel(value);
        const currentStatus = listData?.data_list.find(order => order.order_idx === selectedIds[selectedIds.length - 1])?.order_status;
        const currentLabel = getStatusLabel(currentStatus);

        showPop({
            title:
                value === 7
                    ? " 해당 주문건을 삭제하시겠습니까?"
                    : value === 1
                      ? "해당 주문건을 복구하시겠습니까?"
                      : ` ${currentLabel}${currentLabel === "미확인" ? "을" : "를"} ${selectedLabel}로 주문상태를 변경하시겠습니까?`,
            content: value === 1 ? "복구된 주문건은 주문상태 [미확인],<br />발주상태는 [본점]으로 복구됩니다." : "",
            rightButton: "확인",
            type: value === 7 ? "negative" : "positive",
            onRightClick: () => {
                putOrderStatusMutation.mutate(
                    {
                        order_idx: selectedIds,
                        order_status: value,
                    },
                    {
                        onSuccess: () => {
                            addToast({
                                type: "success",
                                message: value === 1 ? "주문건이 복구되었습니다." : `${name}님이 ${selectedLabel} 상태로 변경하였습니다.`,
                            });
                            setClearSelection(true);
                        },
                        onError: (error: any) => {
                            const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";

                            const isStartsWithCurrent = errorMessage.startsWith("현재");

                            showPop({
                                title: errorMessage,
                                content: isStartsWithCurrent ? "동일한 접수상태이므로 <br />상태를 변경하실 수 없습니다." : undefined,
                                rightButton: undefined,
                                type: "negative",
                                onRightClick: () => {},
                            });
                        },
                    },
                );
            },
        });
    };
    const handleApplyFilter = (newFilterData: any) => {
        setFilterData({
            ...newFilterData,
            selected_customers: newFilterData.selected_customers ?? [],
            selected_branches: newFilterData.selected_branches ?? [],
            selected_customers_full: newFilterData.selected_customers_full ?? [],
            selected_branches_full: newFilterData.selected_branches_full ?? [],
            selected_delivery: newFilterData.selected_delivery || [],
            order_status: newFilterData.order_status || [],
        });
        setCurrentPage(1);
        setInputValue("1");
        setActiveFilterType("detail");
        setHeaderFilter(() => ({
            order_status: null,
            branch_type: null,
            isToday: false,
            photoUnchecked: false,
        }));
    };
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setInputValue(page.toString());
    };
    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (listData?.last_page || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        handlePageChange(pageNumber);
    };
    const handlePageSizeChange = (value: string) => {
        setPageSize(Number(value));
        setCurrentPage(1);
        setInputValue("1");
    };
    const handleClickOutside = (event: MouseEvent) => {
        if (statusRef.current && !statusRef.current.contains(event.target as Node)) {
            setChangeStatus(false);
        }
    };
    const handleSelectRow = (id: number) => {
        const isTabOpen = tabs.some(tab => tab.id === id && tab.type === "detail");

        if (!isTabOpen) {
            setTabs(prev => [{ id, type: "detail" }, ...prev]); // 앞쪽에 추가
        }

        setActiveComponent("TransactionDetail");
        setActiveTabId(id);
    };
    const handleCloseTab = (id: number) => {
        setTabs(prevTabs => {
            const newTabs = prevTabs.filter(tab => tab.id !== id);

            if (activeTabId === id) {
                const currentIndex = prevTabs.findIndex(tab => tab.id === id);
                const nextActiveTab = newTabs[currentIndex - 1] || newTabs[currentIndex] || null;
                setActiveTabId(nextActiveTab ? nextActiveTab.id : null);
            }

            if (newTabs.length === 0) {
                setActiveComponent(null);
            }

            return newTabs;
        });
    };
    const handleOrderNumberChange = (id: number, orderNumber: string) => {
        setTabs(prevTabs => prevTabs.map(tab => (tab.id === id ? { ...tab, orderNumber } : tab)));
    };

    const params = {
        page: currentPage ?? 1,
        pageSize,
        search,
        searchTxt,
        filter: activeFilterType === "header" ? getHeaderFilterAsFilterData() : filterData,
        sortField,
        sortOrder,
        ...(userOrder && { userOrder: "Y" }),
    };
    const {
        data: listData,
        refetch: listRefetch,
        isLoading: isListLoading,
    } = useGetOrder(
        params.page,
        params.pageSize,
        params.search,
        params.searchTxt,
        params.filter,
        params.sortField,
        params.sortOrder,
        params.userOrder,
    );

    const countParams = {
        start_date: filterData.start_date,
        end_date: filterData.end_date,
        ...(userOrder && { userOrder: "Y" }),
    };
    const { data: countData, refetch: countRefetch } = useGetOrderCount({
        start_date: countParams.start_date,
        end_date: countParams.end_date,
        userOrder: countParams.userOrder,
    });
    const { data: cancelData } = useGetCommonCancel(true);
    const { mutate: copyMutate } = usePostCopy(() => {});
    const { mutate: cancelMutate } = usePutOrderCancel();
    const { mutate: receiptMutate } = usePutReceipt();
    const { data: alarmData, refetch } = useGetAlertList();
    const { mutate: alertReadMutate } = usePutAlertRead();
    const deleteOrderMutation = useDeleteOrder();
    const putOrderStatusMutation = usePutOrderStatus();
    const dateParams = {
        start_date: filterData.start_date,
        end_date: filterData.end_date,
        filterData: filterData,
        ...(userOrder && { userOrder: "Y" }),
    };
    const { data: dateData, refetch: dateRefetch } = useGetOrderDateCount(
        dateParams.start_date,
        dateParams.end_date,
        dateParams.filterData,
        dateParams.userOrder,
    );

    const handlePrintReceipt = () => {
        const getBase64Image = (imgUrl: any, callback: any) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.src = imgUrl;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx?.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                callback(dataURL);
            };
        };
        getBase64Image(loginLogo, (base64Logo: any) => {
            receiptMutate(
                { order_idx: selectedIds },
                {
                    onSuccess: data => {
                        const receiptData = data;

                        if (!receiptData) {
                            console.error("인수증 데이터가 없습니다.");
                            return;
                        }
                        // console.log(receiptData);
                        // .container {
                        //     height: 87.9vh;
                        //     max-height: 950px;
                        // }
                        const receiptHtml = `
                <html lang="ko">
                    <head>
                        <title>인수증</title>
                        <style>
                        @page { size: A4 landscape; margin: 0; }
                         @media print {
                            .page-break {
                                page-break-after: always;
                            }
                        }
                        body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                height: 100vh;
                                display: flex;
                                flex-direction: column;
                                align-items: center;    
                                -webkit-print-color-adjust: exact; 
                                print-color-adjust: exact;    
                        }
                        .container {
                                display: flex;
                                width: 98%;
                                max-height: 95vh;
                                max-width: 1800px;
                                gap: 40px;
                                padding-left: 20px;
                                padding-top: 35px;
                        }
                             .receipt {
                                width: 100%;
                                max-width: 450px;
                                background: white;
                            }
                            .delivery-info {
                                width: 100%;
                                max-width: 550px;
                                background: white;
                                margin: 0;
                            }
                            .receipt {
                                border-top: 3px solid black;
                                border-left: 3px solid black;
                                border-right: 2px solid black;
                            }
                            .receipt-header {
                                padding: 20px 18px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                border-bottom: 2px solid black;
                                background-color: #dddddd;
                                gap: 20px;
                            }
                            .receipt-header h1 {
                                font-size: 22px;
                                margin: 0;
                            }
                            .receipt-header p {
                                font-size: 20px;
                                font-weight: bold;
                                margin: 0;
                            }
                            .receipt h1 {
                                text-align: left;
                                font-size: 23px;
                            }
                            .receipt-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 0;
                            }
                            .receipt-table td {
                                padding: 8px;
                                font-size: 18px;
                                border-right: 2px solid black;
                                border-bottom: 2px solid black; 
                            }
                            .receipt-table td:first-child {
                                background-color: #F1F1F1;
                                font-weight: bold;
                                width: 25%;
                                text-align: center;
                                font-size: 15px; 
                                border-bottom: 2px solid black;
                            }
                            .receipt-table td:nth-child(2) {
                                border-left: none;
                                border-right: none;
                                font-size: 15px;
                                font-weight: normal;
                            }
                            .receipt-table tr:nth-child(1) td{
                                height: 78px; 
                            }
                            .receipt-table tr:nth-child(2) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(3) td{
                                height: 64.3px; 
                            }
                            .receipt-table tr:nth-child(4) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(5) td {
                                height: 103px; 
                            }
                            .receipt-table tr:nth-child(6) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(7) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(8) td{
                                height: 58px; 
                            }
                            .receipt-table tr:nth-child(9) td {
                                height: 83px;
                            }
                           .footer {
                                display: flex;
                                flex-direction: column;
                                align-items: start;
                                text-align: left;
                                position: relative;
                                top: -73px; 
                                left: 310px;
                           }
                           .footer img {
                                width: 130px; 
                                height: auto;
                           }
                           .delivery-info {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                           }
                           .delivery-info h2 {
                                background-color: #dddddd;
                                width: 92%;
                                text-align: center;
                                padding: 15px;
                                font-size: 22px;
                                font-weight: bold;
                                border-radius: 7px;
                           }
                           .delivery-item {
                                background-color: #E6EEDD;
                                width: 92%;
                                text-align: center;
                                font-size: 22px;
                                padding: 10px;
                                font-weight: bold;
                                border-radius: 7px;
                           }
                           .delivery-content {
                                width: 92%;
                                text-align: center;
                                font-size: 22px;
                                font-weight: bold;
                                border-radius: 7px;
                                padding: 30px;
                           }
                            .delivery-footer {
                                display: flex;
                                flex-direction: column;
                                align-items: start;
                                text-align: left;
                                font-size: 12px;
                                position: relative;
                                top: 30px;
                                left: 160px;
                           }
                           .delivery-footer img {
                                width: 130px; 
                                height: auto;
                           }
                          .justify-between {
                                display: flex;
                                justify-content: space-between;
                                width: 100%;
                            }
                             .divider {
                                width: 1px;
                                opacity: 50%;
                                background-color: #999;
                                height: 98%;
                                align-self: center;
                            }
                        </style>
                    </head>
                    <body>
                        ${data
                            .map(receipt => {
                                function safeText(str: string) {
                                    return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;");
                                }
                                return `
                        <div class="container page-break">
                            <div class="receipt">
                                <div class="receipt-header">
                                    <h1>인&nbsp;&nbsp;수&nbsp;&nbsp;증</h1>
                                    <p>${receipt.order_number}</p>
                                </div>
                                <table class="receipt-table">
                                    <tr><td>보&nbsp;&nbsp;&nbsp;낸&nbsp;&nbsp;&nbsp;곳</td><td style="white-space:pre-wrap;">${safeText(receipt.wreath_sender)}</td></tr>
                                    <tr>
                                        <td>종류및금액</td>
                                        <td>
                                            <div>
                                                <div class="justify-between">
                                                    <div>
                                                        <span>${receipt.product_name}</span>
                                                        <span>(${receipt?.product_quantity})</span>
                                                    </div>
                                                    <span>${receipt.sales_amount / 10000}</span>
                                                </div>
                                                <div style="word-break:break-word;">${receipt.customer_request !== null ? `<div>${receipt.customer_request}</div>` : ""}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td>내&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;용</td><td>${receipt.wreath_word}</td></tr>
                                    <tr><td>받으시는 분</td><td>  
                                        ${receipt.recipient_name}
                                        ${
                                            receipt.event_content?.depth1 === "직접입력"
                                                ? receipt.event_content?.event_content
                                                    ? ` [${receipt.event_content.event_content}]`
                                                    : ""
                                                : receipt.event_content?.depth1 === "선택안함"
                                                  ? ""
                                                  : receipt.event_content?.depth2
                                                    ? ` [${receipt.event_content.depth2}]`
                                                    : ""
                                        }
                                        ${receipt.related_person ? ` [${receipt.related_person}]` : ""}
                                    </td></tr>
                                    <tr><td>배&nbsp;송&nbsp;주&nbsp;소</td><td>${receipt.delivery_address}<br /> ${receipt.delivery_address_detail}</td></tr>
                                    <tr><td>연&nbsp;&nbsp;&nbsp;락&nbsp;&nbsp;&nbsp;처</td><td>${receipt.recipient_mobile}</td></tr>
                                    <tr><td>배&nbsp;송&nbsp;일&nbsp;시</td><td>${receipt.delivery_date} ${receipt.delivery_time || "없음"}</td></tr>
                                    <tr><td>배&nbsp;송&nbsp;메&nbsp;모</td><td>${receipt.delivery_memo || "없음"}</td></tr>
                                    <tr><td>인&nbsp;&nbsp;&nbsp;수&nbsp;&nbsp;&nbsp;자</td><td style="text-align:right;"><img src="${base64Logo}" alt="Logo" style="width:130px"; /></td></tr>
                                </table>
                            </div>
                            <div class="divider"></div>
                            <div class="delivery-info">
                                <h2>배송 상품에 붙여주세요.</h2>
                                <div class="delivery-item">상품</div>
                                <div class="delivery-content">${receipt.product_name} (${receipt.product_quantity})</div>
                                <div class="delivery-item">받으시는 분</div>
                                <div class="delivery-content">   ${receipt.recipient_name}
                            ${
                                receipt.event_content?.depth1 === "직접입력"
                                    ? receipt.event_content?.event_content
                                        ? ` [${receipt.event_content.event_content}]`
                                        : ""
                                    : receipt.event_content?.depth1 === "선택안함"
                                      ? ""
                                      : receipt.event_content?.depth2
                                        ? ` [${receipt.event_content.depth2}]`
                                        : ""
                            }
                            ${receipt.related_person ? ` [${receipt.related_person}]` : ""}</div>
                                <div class="delivery-item">배송주소</div>
                                <div class="delivery-content">${receipt.delivery_address}<br /> ${receipt.delivery_address_detail}</div>
                                <div class="delivery-footer">
                                    <img src="${base64Logo}" alt="Logo" />
                                    
                               </div>
                            </div>
                        </div>
                        `;
                            })
                            .join("")}

                        <script>
                            window.onload = function() {
                                window.print();
                                setTimeout(() => window.close(), 0);
                            };
                        </script>
                    </body>
                </html> `;

                        const printWindow = window.open("", "_blank", "width=1920,height=1080");
                        if (printWindow) {
                            printWindow.document.open();
                            printWindow.document.write(receiptHtml);
                            printWindow.document.close();
                        }
                    },
                    onError: error => {
                        console.error("인수증 출력 실패:", error);
                    },
                },
            );
        });
    };
    const handleRefresh = async () => {
        setIsRefreshing(true);
        refetch();
        const startTime = Date.now();

        const detailRefetchFunctions = Object.values(detailRefetchMap).filter(refetch => typeof refetch === "function");

        await Promise.all([listRefetch(), countRefetch(), ...detailRefetchFunctions.map(refetch => refetch())]);

        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(100 - elapsedTime, 0);

        setTimeout(() => {
            setIsRefreshing(false);
        }, remainingTime);
    };
    const handleSetRefetch = (tabId: number, refetchFn: () => Promise<any>) => {
        setDetailRefetchMap(prev => {
            if (prev[tabId] === refetchFn) return prev;
            return {
                ...prev,
                [tabId]: refetchFn,
            };
        });
    };

    const [unreadCount, setUnreadCount] = useState(alarmData?.unread_cnt || 0);
    const [alertList, setAlertList] = useState(alarmData?.alert_list || []);

    // 알림 항목을 클릭하면 해당 주문건만 확인 처리되고 상태변경 이력에 기록된다.
    const handleAlertRead = (alert: { alert_idx: number; u_read: boolean }) => {
        if (alert.u_read) return;

        alertReadMutate(alert.alert_idx, {
            onSuccess: () => {
                setAlertList(prev => prev.map(item => (item.alert_idx === alert.alert_idx ? { ...item, u_read: true } : item)));
                setUnreadCount(prev => (prev > 0 ? prev - 1 : 0));
            },
            onError: () => {
                addToast({
                    type: "error",
                    message: "알림 확인에 실패했습니다.",
                });
            },
        });
    };

    const handleDeleteSubmit = () => {
        showPop({
            title: " 해당 주문건을 영구적으로 <br/> 삭제하시겠습니까?",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                deleteOrderMutation.mutate(
                    {
                        order_idx: selectedIds,
                    },
                    {
                        onSuccess: () => {
                            addToast({
                                type: "error",
                                message: "해당 주문건이 영구적으로 삭제되었습니다.",
                            });
                        },
                        onError: (error: any) => {
                            const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";

                            showPop({
                                title: errorMessage,
                                rightButton: undefined,
                                type: "negative",
                                onRightClick: () => {},
                            });
                        },
                    },
                );
            },
        });
    };

    useEffect(() => {
        if (alarmData) {
            setUnreadCount(alarmData.unread_cnt);
            setAlertList(alarmData.alert_list);
        }
    }, [alarmData]);
    useEffect(() => {
        if (changeStatus) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [changeStatus]);
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    }, [activeTabId]);
    useEffect(() => {
        listRefetch();
        dateRefetch();
    }, [filterData]);

    /* 오른쪽 패널(상세·신규주문)이 열려 있는지. 열리면 헤더 자리가 그만큼 줄어든다 */
    const isPanelOpen = (tabs.length > 0 && activeComponent === "TransactionDetail") || activeComponent === "NewOrder";

    /*
    // 화면이 좁아 패널(560px) 옆에 표를 둘 자리가 없는지(1023px 이하면 표 자리가 384px 이하).
    // 이때 패널이 열리면 표를 접지 않고 패널이 닫혔을 때와 같은 폭으로 두고, 페이지 전체를
    // 표+패널 폭으로 넓혀 가로로 밀어 본다. 표 자리를 줄이면 표가 0 폭이 되어 안 보인다.
    */
    const [isNarrow, setIsNarrow] = useState(() => window.matchMedia("(max-width: 1023px)").matches);
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 1023px)");
        const onChange = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);
    /* 패널 때문에 헤더를 접고 표를 남는 폭에 맞출지. 좁은 화면에서는 접지 않는다 */
    const foldForPanel = isPanelOpen && !isNarrow;

    /*
    // 좁은 화면에서는 패널이 표 오른쪽 끝, 화면 밖에 생긴다. 행을 눌러도 아무 일 없어 보이지 않게
    // 패널을 열거나 탭을 바꾸면 패널이 보이는 곳까지 페이지를 가로로 민다. 세로 위치는 건드리지 않는다.
    */
    const panelRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (isNarrow && isPanelOpen) panelRef.current?.scrollIntoView({ inline: "end", block: "nearest" });
    }, [isNarrow, isPanelOpen, activeComponent, activeTabId]);

    return (
        /*
        // 페이지 최소 폭은 min-w-min(안에 든 것들의 최소 폭) 하나로 잡는다. 넓은 화면에서 가운데 영역은
        // w-0 이라 최소 폭에 보태지 않으므로 사실상 패널 폭이다. 좁은 화면에서 패널이 열리면 가운데
        // 영역이 min-w-max 라 표+패널 폭이 되고, 화면 전체가 가로로 밀린다. 예전처럼 overflow-hidden
        // 으로 자르면 패널 오른쪽이 잘린 채 어디로도 스크롤되지 않는다.
        //
        // 높이는 100vh(h-screen)가 아니라 100dvh(h-dvh)로 잡는다. 안드로이드는 100vh 를 주소창이
        // 숨겨진 상태의 높이로 계산해 화면 아래쪽이 주소창 뒤에 가려진다.
        */
        <div className="flex h-dvh min-w-min">
            {(isListLoading || isRefreshing) && <Spinner />}
            {/*
            // 헤더와 표가 한 덩어리로 가로 스크롤된다. 패널은 이 영역 밖이라 항상 제자리에 있다.
            // overflow-y 를 hidden 으로 못박는다. x 만 주면 y 도 auto 로 승격돼 헤더까지 세로로 밀린다.
            // w-0 은 폭을 0 으로 고정하는 게 아니라, 표 폭이 페이지 최소 폭에 섞이지 않게 하는 것이다.
            // 실제 폭은 flex-1 로 남는 폭을 다 받는다. 좁은 화면에서 패널이 열렸을 때만 내용 폭(min-w-max)이다.
            */}
            <div
                ref={centerRef}
                className={`flex flex-1 ${isPanelOpen && isNarrow ? "min-w-max" : "w-0 min-w-0"} flex-col overflow-x-auto overflow-y-hidden`}
            >
                {/*
                // 헤더가 표보다 넓으면, 가로로 밀었을 때 헤더만 이어지고 표는 자기 폭에서 끝나
                // 그 차이가 흰 여백으로 보인다. w-max 로 이 래퍼를 가장 넓은 자식(헤더)에 맞추고
                // min-w-full 로 최소한 화면 폭은 채우면, 표도 같은 폭까지 늘어난다.
                // 단, 오른쪽 패널이 열리면 w-max 가 헤더를 한 줄 폭(약 1400px)으로 고정해 가로 스크롤이 생긴다.
                // 그때는 화면 폭에 맞추고 헤더 줄들을 접는다(flex-wrap). 표는 패널용 좁은 폭이라 들어간다.
                // 최소 폭은 고정값이 아니라 min-w-min(안에 든 것들의 최소 폭, 사실상 표의 최소 폭)으로 잡는다.
                // 고정값이 표보다 작으면 표가 래퍼를 넘쳐 표 쪽에 가로 스크롤바가 하나 더 생긴다.
                // 화면이 이보다 좁으면 헤더와 표가 바깥 스크롤 하나로 같이 밀린다.
                */}
                <div className={`flex h-full ${foldForPanel ? "w-full min-w-min" : "w-max min-w-full"} flex-col`}>
                    {/* Header */}
                    <div
                        className={`flex flex-col gap-2 whitespace-nowrap px-3 border-b border-gray4 ${alarmData?.unread_cnt !== 0 ? "py-2" : "py-3"}`}
                    >
                        <div className="flex justify-between gap-2">
                            {/* 패널이 열리면 오른쪽(페이지 이동·공유메모)을 남겨두고 이 묶음이 남는 폭에 맞춰 안에서 접힌다 */}
                            {/*
                            // 패널이 열리면 min-w-0 으로 남는 폭까지 줄어들며 안에서 접힌다.
                            // flex-1 은 주지 않는다. 넓은 화면에서 남는 폭을 다 차지해 주문상태 칸이 길게 늘어난다.
                            */}
                            <div className={`flex-col flex gap-2 ${foldForPanel ? "min-w-0" : ""}`}>
                                <div className={`flex gap-2 items-center ${foldForPanel ? "flex-wrap" : ""}`}>
                                    {filterData.order_status.includes(7) && (
                                        <button
                                            onClick={() => {
                                                setClearSelection(true);

                                                setFilterData(prev => ({
                                                    ...prev,
                                                    order_status: prev.order_status.filter(status => status !== 7),
                                                }));
                                            }}
                                            className="border border-gray4 rounded-lg w-[34px] h-[34px] flex items-center justify-center"
                                        >
                                            <ArrowLeft />
                                        </button>
                                    )}
                                    <p className="text-xl ml-1">{!filterData.order_status.includes(7) ? "주문판매" : "삭제건만 보기"}</p>
                                    <div className={`flex items-center ${foldForPanel ? "flex-wrap gap-y-1" : ""}`}>
                                        <p className="text-sm font-bold ml-2">매출 및 주문상태</p>
                                        <div className="flex gap-1 mx-2">
                                            <Button
                                                status={selectedQuickFilter === "prevMonth" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const prevMonth = subMonths(new Date(), 1);
                                                    const start = startOfMonth(prevMonth);
                                                    const end = endOfMonth(prevMonth);
                                                    handleQuickFilterClick(
                                                        "prevMonth",
                                                        format(start, "yyyy-MM-dd"),
                                                        format(end, "yyyy-MM-dd"),
                                                        "전월",
                                                    );
                                                }}
                                            >
                                                전월
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "yesterday" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const date = subDays(new Date(), 1);
                                                    const formatted = format(date, "yyyy-MM-dd");
                                                    handleQuickFilterClick("yesterday", formatted, formatted, "전일");
                                                }}
                                            >
                                                전일
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "today" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const today = startOfToday();
                                                    const formatted = format(today, "yyyy-MM-dd");
                                                    handleQuickFilterClick("today", formatted, formatted, "오늘");
                                                }}
                                            >
                                                오늘
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "tomorrow" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const tomorrow = addDays(new Date(), 1);
                                                    const formatted = format(tomorrow, "yyyy-MM-dd");
                                                    handleQuickFilterClick("tomorrow", formatted, formatted, "내일");
                                                }}
                                            >
                                                내일
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "week" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const start = startOfWeek(new Date(), { weekStartsOn: 1 });
                                                    const end = endOfWeek(new Date(), { weekStartsOn: 1 });
                                                    handleQuickFilterClick(
                                                        "week",
                                                        format(start, "yyyy-MM-dd"),
                                                        format(end, "yyyy-MM-dd"),
                                                        "금주",
                                                    );
                                                }}
                                            >
                                                금주
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "month" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const start = startOfMonth(new Date());
                                                    const end = endOfMonth(new Date());
                                                    handleQuickFilterClick(
                                                        "month",
                                                        format(start, "yyyy-MM-dd"),
                                                        format(end, "yyyy-MM-dd"),
                                                        "당월",
                                                    );
                                                }}
                                            >
                                                당월
                                            </Button>
                                            <Button
                                                status={selectedQuickFilter === "nextMonth" ? "regist" : undefined}
                                                size="S"
                                                className="px-2"
                                                onClick={() => {
                                                    const nextMonth = addMonths(new Date(), 1);
                                                    const start = startOfMonth(nextMonth);
                                                    const end = endOfMonth(nextMonth);
                                                    handleQuickFilterClick(
                                                        "nextMonth",
                                                        format(start, "yyyy-MM-dd"),
                                                        format(end, "yyyy-MM-dd"),
                                                        "익월",
                                                    );
                                                }}
                                            >
                                                익월
                                            </Button>
                                        </div>

                                        <p className="flex font-bold items-center gap-2 text-sm text-red-500">
                                            합계
                                            <span className="">{dateData?.total_sales_amount.toLocaleString()} 원</span>
                                            <span className="">({dateData?.total_order_count.toLocaleString()}건)</span>
                                        </p>

                                        <Button
                                            status={userOrder ? "regist" : undefined}
                                            size="S"
                                            className="px-2 ml-2"
                                            onClick={() => {
                                                setUserOrder(prev => !prev);
                                            }}
                                        >
                                            사용자 주문
                                        </Button>
                                        <Button
                                            size="S"
                                            className="px-2 ml-1"
                                            onClick={() => {
                                                setSalesStatisticsPopup(true);
                                            }}
                                        >
                                            매출 통계현황
                                        </Button>
                                    </div>
                                </div>
                                {/* self-start: 세로 flex 기본값(stretch)이면 윗줄 폭만큼 배경이 늘어난다 */}
                                {!filterData.order_status.includes(7) && (
                                    <div
                                        className={`self-start bg-gray6 py-2 px-6 rounded-[20px] flex gap-4 items-center ${foldForPanel ? "flex-wrap gap-y-1" : ""}`}
                                    >
                                        <div className={`flex gap-4 items-center ${foldForPanel ? "flex-wrap gap-y-1" : ""}`}>
                                            <div className={`gap-3 flex`}>
                                                <p className="text-sm font-bold">주문상태</p>
                                                <div className={`flex items-center gap-2 ${foldForPanel ? "flex-wrap" : ""}`}>
                                                    {[
                                                        { label: "미확인", value: 1 },
                                                        { label: "접수완료", value: 2 },
                                                        { label: "준비완료", value: 3 },
                                                        { label: "배송완료", value: 4 },
                                                        { label: "취소", value: 5 },
                                                        { label: "보류", value: 6 },
                                                    ].map(({ label, value }) => {
                                                        const statusCount =
                                                            countData?.order.find(order => order.order_status === value)?.count || 0;

                                                        return (
                                                            <Fragment key={value}>
                                                                <div className="flex items-center gap-1">
                                                                    <p
                                                                        className={`text-xs ${headerFilter.order_status === value ? "font-bold" : ""} ${label === "미확인" && "text-warning"}`}
                                                                    >
                                                                        {label}
                                                                    </p>
                                                                    <button
                                                                        style={{
                                                                            fontWeight:
                                                                                headerFilter.order_status === value ? "bold" : "normal",
                                                                        }}
                                                                        className={`text-sm underline ${
                                                                            label === "미확인"
                                                                                ? "text-warning"
                                                                                : headerFilter.order_status === value
                                                                                  ? "text-[#00489D]"
                                                                                  : "text-primary2"
                                                                        }`}
                                                                        onClick={() => handleOrderStatusClick(value)}
                                                                    >
                                                                        {statusCount.toLocaleString()}
                                                                    </button>
                                                                </div>
                                                                {/* 지점이 올린 준비완료 사진 중 아직 확인하지 않은 건수.
                                                            목록 썸네일이 점멸하는 조건과 같은 기준이며,
                                                            숫자를 누르면 해당 건만 필터링된다 */}
                                                                {value === 3 && (
                                                                    <div className="flex items-center gap-1">
                                                                        <p
                                                                            className={`text-xs text-error ${headerFilter.photoUnchecked ? "font-bold" : ""}`}
                                                                        >
                                                                            사진미확인
                                                                        </p>
                                                                        <button
                                                                            className={`text-sm font-bold text-error underline ${
                                                                                headerFilter.photoUnchecked ? "text-[#00489D]" : ""
                                                                            }`}
                                                                            onClick={handlePhotoUncheckedClick}
                                                                        >
                                                                            {(countData?.photo_unchecked_count || 0).toLocaleString()}
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </Fragment>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className={`w-1 h-1 bg-gray4 rounded-full ${activeComponent && "hidden ssm:flex"}`} />
                                            <div className={`gap-3 ${activeComponent && "hidden xl:flex"} flex`}>
                                                <p className="text-sm font-bold">발주상태</p>
                                                {[
                                                    { label: "본점", value: 1 },
                                                    { label: "타지점", value: 2 },
                                                ].map(({ label, value }) => {
                                                    const branchCount =
                                                        countData?.branch.find(branch => branch.branch_type === value)?.count || 0;
                                                    return (
                                                        <div key={value} className="flex items-center gap-1">
                                                            <p
                                                                className={`text-xs ${headerFilter.branch_type === value ? "font-bold" : ""}`}
                                                            >
                                                                {label}
                                                            </p>
                                                            <button
                                                                className={`text-sm underline  ${
                                                                    headerFilter.branch_type === value
                                                                        ? "font-bold text-[#00489D]"
                                                                        : "text-primary2"
                                                                }`}
                                                                onClick={() => handleBranchTypeClick(value)}
                                                            >
                                                                {branchCount.toLocaleString()}
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div
                                            className="flex items-center gap-1 cursor-pointer"
                                            onClick={() => {
                                                setActiveFilterType("detail");
                                                setSelectedIds([]);
                                                setCurrentPage(1);
                                                setInputValue("1");
                                                setClearSelection(true);
                                                setFilterData(prev => {
                                                    const isDeleteActive = prev.order_status.includes(7);

                                                    return isDeleteActive
                                                        ? {
                                                              ...prev,
                                                              order_status: [],
                                                              branch_type: [],
                                                          }
                                                        : {
                                                              ...prev,
                                                              order_status: [7],
                                                              branch_type: [],
                                                          };
                                                });
                                            }}
                                        >
                                            <Trashcan />

                                            <p
                                                className={`text-sm underline text-text-gray2 ${
                                                    filterData.order_status.includes(7) ? "font-bold text-[#00489D]" : ""
                                                }`}
                                            >
                                                삭제
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/*
                            // 왼쪽 묶음 뒤 남는 폭을 공유메모와 페이지 이동이 나눠 쓴다.
                            // 둘이 한 줄에 안 들어가면 메모가 아랫줄로 넘어간다. wrap-reverse 라 먼저 놓인 메모가
                            // 아래 줄, 넘친 페이지 이동이 위 줄이 되어 페이지 이동은 항상 맨 위에 남는다.
                            // 패널 열림 여부가 아니라 실제 남는 폭으로 갈리므로 자리가 넉넉하면 패널이 열려도 한 줄이다.
                            */}
                            <div className="flex flex-1 flex-wrap-reverse items-center gap-y-2">
                                {/* 일자별 공유 메모. 조회 기간의 시작일을 따라가고, 기간 해제 상태면 오늘 날짜를 쓴다 */}
                                <DailyMemo memoDate={filterData.start_date || format(startOfToday(), "yyyy-MM-dd")} />
                                <div className="flex items-center gap-2 ml-auto">
                                    <button onClick={() => currentPage && currentPage > 1 && handlePageChange(currentPage - 1)}>
                                        <LeftArrow />
                                    </button>
                                    <Input
                                        inputClassName="text-center"
                                        className="w-20 text-center outline-0 text-sm flex"
                                        value={inputValue}
                                        onChange={e => handlePageInput(e.target.value)}
                                    />
                                    <p className="text-gray3">/ {listData?.last_page}</p>
                                    <button
                                        onClick={() =>
                                            currentPage && currentPage < (listData?.last_page || 1) && handlePageChange(currentPage + 1)
                                        }
                                    >
                                        <RightArrow />
                                    </button>
                                    <div className={`relative`}>
                                        <button
                                            onClick={() => {
                                                setAlarmPop(true);
                                            }}
                                            className={`flex flex-col items-center  justify-center rounded-xl`}
                                        >
                                            <Alarm className="w-[24px] h-[24px] z-10" />
                                            {unreadCount !== 0 && (
                                                <p className="animate-blink bg-error text-white w-[32px] rounded-[20px] text-xs -translate-y-1.5">
                                                    {unreadCount}
                                                </p>
                                            )}
                                        </button>
                                        {alarmPop && (
                                            <div className="absolute top-[35px] right-0 w-[300px] z-50 shadow-custom bg-white rounded-xl min-h-[755px] h-[755px] flex flex-col">
                                                <div className="flex items-center justify-between z-50 p-3 border-b border-gray4">
                                                    <p className="text-gray2 font-bold text-xl">알림</p>
                                                    <CloseIcon
                                                        className="cursor-pointer"
                                                        onClick={() => {
                                                            refetch();
                                                            setAlarmPop(false);
                                                        }}
                                                    />
                                                </div>
                                                {alertList.length || 0 > 0 ? (
                                                    <div className="flex-1 overflow-y-auto">
                                                        {alertList.map(item => (
                                                            <div
                                                                key={item.alert_idx}
                                                                onClick={() => handleAlertRead(item)}
                                                                className={`flex gap-2 p-3 border-b border-gray4 z-50 ${
                                                                    item.u_read ? "bg-white" : "bg-gray5 cursor-pointer"
                                                                }`}
                                                            >
                                                                <ToastNotice className="min-w-6 min-h-6" />
                                                                <div className="flex flex-col gap-1">
                                                                    <p className="font-bold">{item.contents}</p>
                                                                    <p className="text-gray2 text-sm">{item.reg_date}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-grayicon flex justify-center items-center h-full">
                                                        알림 내역이 없습니다.
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Title */}
                    <div
                        className={`flex justify-between whitespace-nowrap p-3 items-center border-b border-gray4 ${foldForPanel ? "flex-wrap gap-2" : ""}`}
                    >
                        <div className={`flex gap-2 ${foldForPanel ? "flex-wrap" : ""}`}>
                            <div className="flex items-center gap-1">
                                <p className="text-xs">총</p>
                                <button className="text-sm font-bold text-primary2">{listData?.total_count.toLocaleString()}</button>
                            </div>
                            <div className="flex items-center gap-1">
                                <p className="text-xs">선택</p>
                                <button className="text-sm font-bold text-primary2">{selectedIds.length.toLocaleString()}</button>
                            </div>

                            {filterData.order_status.includes(7)
                                ? level !== 7 && (
                                      <div className="flex gap-2">
                                          <button
                                              onClick={() => handleStatusSubmit(1)}
                                              className={`bg-primary3 text-sm text-primary1 px-2 py-1.5 rounded-md`}
                                          >
                                              주문판매 내역으로 복구
                                          </button>
                                          <Button status="error" size="S" className="px-2" onClick={() => handleDeleteSubmit()}>
                                              영구 삭제
                                          </Button>
                                      </div>
                                  )
                                : level !== 7 && (
                                      <div className={`${activeComponent && "hidden xl:flex"} flex gap-4 items-center`}>
                                          <div className="flex gap-1 items-center relative">
                                              <Button
                                                  disabled={selectedIds.length === 0}
                                                  onClick={() => setChangeStatus(true)}
                                                  size="S"
                                                  icon={<SelectIcon />}
                                                  iconPosition="right"
                                                  className="px-2"
                                              >
                                                  일괄 주문상태 변경
                                              </Button>
                                              {changeStatus && (
                                                  <div
                                                      ref={statusRef}
                                                      className="absolute left-0 top-0 p-2 translate-y-9 bg-white border rounded-xl shadow z-10 w-[144px] "
                                                  >
                                                      {statusOptions.map(option => (
                                                          <button
                                                              key={option.value}
                                                              className="block w-full hover:text-primary2 rounded-lg hover:bg-primary4 text-gray2 px-4 py-2 text-center"
                                                              onClick={() => {
                                                                  setChangeStatus(false);
                                                                  handleStatusSubmit(option.value);
                                                              }}
                                                          >
                                                              {option.label}
                                                          </button>
                                                      ))}
                                                  </div>
                                              )}
                                              <Button
                                                  onClick={handleSaveCopy}
                                                  disabled={selectedIds.length === 0}
                                                  icon={<CopyIcon />}
                                                  iconPosition="right"
                                                  size="S"
                                                  className="px-2"
                                              >
                                                  복사
                                              </Button>
                                              <Button
                                                  size="S"
                                                  className="px-2"
                                                  disabled={selectedIds.length === 0}
                                                  onClick={handlePrintReceipt}
                                              >
                                                  인수증 출력
                                              </Button>
                                              {level !== 8 && (
                                                  <>
                                                      <Button
                                                          disabled={selectedIds.length === 0}
                                                          size="S"
                                                          className="px-2"
                                                          onClick={() => {
                                                              handleStatusSubmit(7);
                                                          }}
                                                      >
                                                          삭제
                                                      </Button>
                                                      <div className="relative">
                                                          <Button
                                                              disabled={selectedIds.length === 0}
                                                              size="S"
                                                              className="px-2"
                                                              status="error"
                                                              onClick={() => setCancelPop(true)}
                                                          >
                                                              주문취소
                                                          </Button>
                                                          {cancelPop && (
                                                              <div className="absolute mt-2 w-[480px] shadow-custom  bg-white z-10 rounded-2xl">
                                                                  <div className="flex items-center justify-between px-6 py-5">
                                                                      <p className="text-[#1C1C1E] font-bold text-2xl">주문취소</p>
                                                                      <CloseBlackIcon
                                                                          className="cursor-pointer"
                                                                          onClick={() => {
                                                                              setCancelPop(false);
                                                                              setCancelDetail("");
                                                                              setCancel(0);
                                                                              setCancelError(false);
                                                                          }}
                                                                      />
                                                                  </div>
                                                                  <div className="text-xl font-bold flex px-6 mb-4">
                                                                      <p>선택한 내역</p>
                                                                      <p className="text-error pl-1">{selectedIds.length}</p>
                                                                      <p>개를 일괄 주문취소 합니다.</p>
                                                                  </div>
                                                                  <div className="bg-[#F3F3F8] p-3 flex flex-col">
                                                                      <div className="flex">
                                                                          <TableName required>취소사유</TableName>
                                                                          <SelectBox
                                                                              status={cancelError ? "error" : ""}
                                                                              placeholder="선택"
                                                                              options={
                                                                                  cancelData?.data
                                                                                      ? [
                                                                                            ...cancelData.data.map(cancel => ({
                                                                                                value: cancel.cancel_reason_idx.toString(),
                                                                                                label: cancel.cancel_reason,
                                                                                            })),
                                                                                        ]
                                                                                      : []
                                                                              }
                                                                              full
                                                                              className="w-full m-[7px] bg-white"
                                                                              value={cancel.toString()}
                                                                              onChange={value => {
                                                                                  setCancel(value);
                                                                                  setCancelError(false);
                                                                              }}
                                                                          />
                                                                      </div>
                                                                      <div className="flex">
                                                                          <TableName>상세사유</TableName>
                                                                          <Input
                                                                              maxLength={100}
                                                                              placeholder="100자"
                                                                              className="p-2 w-full"
                                                                              value={cancelDetail}
                                                                              onChange={e => setCancelDetail(e.target.value)}
                                                                          />
                                                                      </div>
                                                                  </div>
                                                                  <div className="flex w-full gap-2 py-2 px-3">
                                                                      <Button
                                                                          className="w-full"
                                                                          size="L"
                                                                          onClick={() => {
                                                                              setCancelPop(false);
                                                                              setCancelDetail("");
                                                                              setCancel(0);
                                                                              setCancelError(false);
                                                                          }}
                                                                      >
                                                                          취소
                                                                      </Button>
                                                                      <Button
                                                                          onClick={handleSaveCancel}
                                                                          status="regist"
                                                                          className="w-full"
                                                                          size="L"
                                                                      >
                                                                          저장
                                                                      </Button>
                                                                  </div>
                                                              </div>
                                                          )}
                                                      </div>
                                                  </>
                                              )}
                                          </div>
                                      </div>
                                  )}
                        </div>
                        <div className={`flex gap-2 items-center z-10 ${foldForPanel ? "flex-wrap justify-end ml-auto" : ""}`}>
                            <button>
                                <Refresh onClick={handleRefresh} className="cursor-pointer" />
                            </button>
                            {level !== 7 && (
                                <Button
                                    onClick={() => {
                                        setActiveComponent("NewOrder");
                                    }}
                                    size="S"
                                    status="regist"
                                    className="px-2"
                                >
                                    신규주문 등록
                                </Button>
                            )}
                            <SelectBox
                                status="none"
                                className="w-[100px]"
                                options={[
                                    { value: "50", label: "50건씩" },
                                    { value: "100", label: "100건씩" },
                                ]}
                                value={pageSize.toString()}
                                onChange={handlePageSizeChange}
                            />
                            <div className="relative">
                                <Filter className="cursor-pointer" onClick={() => setFilterClick(!filterClick)} />
                                {filterClick && (
                                    <div className="absolute top-8 -right-72 bg-white z-50 rounded-2xl">
                                        <FilterDetail
                                            filterData={filterData}
                                            onApplyFilter={handleApplyFilter}
                                            onClose={() => setFilterClick(false)}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="w-[240px] flex gap-1">
                                <SelectBox
                                    status="none"
                                    className="min-w-[110px]"
                                    options={[
                                        { value: "all_search", label: "전체검색" },
                                        { value: "customer_name", label: "고객명" },
                                        { value: "order_name", label: "주문자" },
                                        { value: "recipient_name", label: "받으시는 분" },
                                        { value: "branch_name", label: "타지점명" },
                                        { value: "delivery_address", label: "배송주소" },
                                        { value: "order_number", label: "배송일자명" },
                                        { value: "manager_name", label: "담당자" },
                                        { value: "product_name", label: "상품명" },
                                    ]}
                                    value={search}
                                    onChange={(value: string) => setSearch(value)}
                                />
                                <Input
                                    placeholder="검색"
                                    status="none"
                                    className=""
                                    value={searchTxt}
                                    onChange={e => {
                                        setSearchTxt(e.target.value);
                                        setInputValue("1");
                                        setCurrentPage(1);
                                    }}
                                />
                            </div>
                            <div>
                                <Button
                                    onClick={() => {
                                        setExcelClick(prev => !prev);
                                    }}
                                    size="S"
                                    className="px-2"
                                    icon={<SelectIcon className={`${excelClick ? "rotate-180" : ""}`} />}
                                    iconPosition="right"
                                >
                                    엑셀
                                </Button>
                                {excelClick && (
                                    <Excel
                                        onDateSubmit={(start, end) => {
                                            setFilterData(prev => ({ ...prev, start_date: start || "", end_date: end || "" }));
                                        }}
                                        selectedIds={selectedIds}
                                        onClose={() => setExcelClick(false)}
                                    />
                                )}
                            </div>
                            <button
                                onClick={() => {
                                    activeComponent ? setActiveComponent(null) : setActiveComponent("TransactionDetail");
                                }}
                                disabled={activeComponent !== "NewOrder" && tabs.length === 0}
                                className={`border border-gray-4 p-1 rounded-lg ${
                                    activeComponent ? "rotate-180" : ""
                                } ${activeComponent !== "NewOrder" && tabs.length === 0 ? "cursor-default" : "cursor-pointer"}`}
                            >
                                <ArrowLeft />
                            </button>
                        </div>
                    </div>
                    {/*
                // 폭은 flex 가 잡게 둔다. 예전엔 calc(100vw - 640px) 을 직접 넣었는데,
                // 루트가 min-w-max 라 페이지가 뷰포트보다 넓어서 그만큼 모자라게 잡혔다.
                // 상세 패널을 열면 표 오른쪽에 흰 여백이 남던 원인이다.
                */}
                    <div className="flex-1 overflow-y-auto">
                        <TransactionTable
                            selectedRows={setSelectedIds}
                            selectedRow={handleSelectRow}
                            tableClick={activeComponent}
                            /* 기본 폭 표(최소 약 1320px)에 배송주소 자리까지 남길 수 있는 폭보다 좁으면 칸을 좁힌다 */
                            compact={centerWidth !== null && centerWidth < 1400}
                            data={listData?.data_list}
                            clearTrigger={clearSelection}
                            onClearComplete={() => setClearSelection(false)}
                            activeTabId={activeTabId}
                            field={handleSortField}
                        />
                    </div>
                </div>
            </div>
            {tabs.length > 0 && activeComponent === "TransactionDetail" && (
                <div ref={panelRef} className="bg-gray6 overflow-hidden shrink-0 min-w-[560px] max-w-[560px] h-dvh flex flex-col z-50 shadow-custom">
                    {/* 탭 영역 */}
                    <div className=" sticky top-0 z-10 mx-4 overflow-x-auto">
                        <div className="flex pt-4  w-max">
                            {tabs.map(tab => (
                                <div
                                    key={tab.id}
                                    className={`text-sm flex items-center rounded-t-lg justify-between min-w-[140px] cursor-pointer px-2 py-1.5 ${
                                        activeTabId === tab.id ? "bg-white" : "bg-gray5 text-gray3"
                                    }`}
                                    onClick={() => setActiveTabId(tab.id)}
                                >
                                    {tab.orderNumber}
                                    <button
                                        onClick={e => {
                                            e.stopPropagation();
                                            handleCloseTab(tab.id);
                                        }}
                                    >
                                        <CloseBlackIcon className="w-4 h-4" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* 내용 영역 */}
                    <div className="flex-1 overflow-y-auto" ref={scrollContainerRef}>
                        {tabs.map(tab => (
                            <div key={tab.id} className={`${activeTabId === tab.id ? "block" : "hidden"} h-full`}>
                                <TransactionDetail
                                    key={tab.id}
                                    onOrderNumberChange={orderNumber => handleOrderNumberChange(tab.id, orderNumber)}
                                    selectedIdx={tab.id}
                                    onRefresh={refetchFn => handleSetRefetch(tab.id, refetchFn)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* 신규주문 등록 */}
            {activeComponent === "NewOrder" && (
                <div ref={panelRef} className="shrink-0 min-w-[560px] max-w-[560px] h-dvh bg-white overflow-y-auto flex flex-col z-50 shadow-custom">
                    <NewOrder onComplete={handleNewOrderComplete} />
                </div>
            )}

            {salesStatisticsPopup && (
                <div className="min-w-[800px] max-w-[800px] max-h-[80dvh] h-full px-6 py-4 bg-white flex flex-col z-50 shadow-custom fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-2xl">
                    <div className="flex items-center justify-between">
                        <p className="text-2xl font-bold">매출 통계현황</p>
                        <button onClick={() => setSalesStatisticsPopup(false)}>
                            <CloseBlackIcon className="w-4 h-4" />
                        </button>
                    </div>
                    <div className="py-5">
                        <div className="flex items-center gap-2">
                            <DayPickerInput
                                maxDate={salesStatisticsOrderDate.end_date ? new Date(salesStatisticsOrderDate.end_date) : undefined}
                                onDateChange={date => {
                                    // setDateError(false);
                                    setSalesStatisticsOrderDate(prev => ({
                                        ...prev,
                                        start_date: date
                                            ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                            : "",
                                    }));
                                }}
                                className={`border-gray4 border h-full rounded-lg p-2`}
                                initialDate={
                                    salesStatisticsOrderDate.start_date ? new Date(salesStatisticsOrderDate.start_date) : undefined
                                }
                            />
                            <span>~</span>
                            <DayPickerInput
                                minDate={salesStatisticsOrderDate.start_date ? new Date(salesStatisticsOrderDate.start_date) : undefined}
                                onDateChange={date => {
                                    // setDateError(false);
                                    setSalesStatisticsOrderDate(prev => ({
                                        ...prev,
                                        end_date: date
                                            ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                                            : "",
                                    }));
                                }}
                                className={`border-gray4 border h-full rounded-lg p-2`}
                                initialDate={salesStatisticsOrderDate.end_date ? new Date(salesStatisticsOrderDate.end_date) : undefined}
                            />
                            <Button
                                status="regist"
                                size="S"
                                className="px-2 ml-2 py-2"
                                onClick={() => {
                                    getSalesStatistics({
                                        start_order_date: salesStatisticsOrderDate.start_date,
                                        end_order_date: salesStatisticsOrderDate.end_date,
                                    });
                                }}
                                disabled={isSalesStatisticsLoading}
                            >
                                조회
                            </Button>
                        </div>
                    </div>
                    <div className="mt-4 overflow-y-auto max-h-[calc(100%-100px)]">
                        {isSalesStatisticsLoading ? (
                            <Spinner />
                        ) : (
                            <>
                                {salesStatisticsData && salesStatisticsData.length > 0 ? (
                                    <div className="overflow-auto">
                                        <table className="w-full text-sm border-t border-[#999999] text-gray2">
                                            <thead className="h-10 border-b border-[#DDDDDD] bg-gray-50">
                                                <tr>
                                                    <th className="text-left px-4">주문일</th>
                                                    <th className="text-right px-4">판매건수</th>
                                                    <th className="text-right px-4">판매금액</th>
                                                    <th className="text-right px-4">입금건수</th>
                                                    <th className="text-right px-4">입금액</th>
                                                    <th className="text-right px-4">미수금액</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesStatisticsData.map((item, index) => {
                                                    // 문자열인 경우 콤마 제거 후 숫자로 변환
                                                    const parseAmount = (value: number | string): number => {
                                                        if (typeof value === "string") {
                                                            return Number(value.replace(/,/g, "")) || 0;
                                                        }
                                                        return value;
                                                    };

                                                    return (
                                                        <tr key={index} className="border-b border-[#DDDDDD] hover:bg-gray-50">
                                                            <td className="px-4 py-2">{item.order_date}</td>
                                                            <td className="text-right px-4 py-2">{makeIntComma(item.sale_count)}</td>
                                                            <td className="text-right px-4 py-2">
                                                                {makeIntComma(parseAmount(item.sale_amount))}원
                                                            </td>
                                                            <td className="text-right px-4 py-2">{makeIntComma(item.payment_count)}</td>
                                                            <td className="text-right px-4 py-2">
                                                                {makeIntComma(parseAmount(item.payment_amount))}원
                                                            </td>
                                                            <td className="text-right px-4 py-2">
                                                                {makeIntComma(parseAmount(item.outstanding_amount))}원
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-8 text-gray-400">데이터가 없습니다.</div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Transaction;
